var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.9543 8.95431 0 20 0H50C61.0457 0 70 8.95431 70 20V50C70 61.0457 61.0457 70 50 70H20C8.9543 70 0 61.0457 0 50V20Z",
    fill: "#F1935C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9998 32C38.3135 32 40.9998 29.3137 40.9998 26C40.9998 22.6863 38.3135 20 34.9998 20C31.686 20 28.9998 22.6863 28.9998 26C28.9998 29.3137 31.686 32 34.9998 32Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 50.9999C41.299 50.9999 46 48.3136 46 44.9999C46 41.6862 41.299 38.9999 35.5 38.9999C29.701 38.9999 25 41.6862 25 44.9999C25 48.3136 29.701 50.9999 35.5 50.9999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.6723fd59b3d09a16a72c564b4c6ba367.svg";
export { ForwardRef as ReactComponent };